import React from 'react';
import { Container } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

import { loadAuthorizedAccountsAfterLogin } from '../actions/auth';
import LoginComponent from '../components/LoginComponent';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      loading: false,
      success: false,
      error: false,
    };
  }

  componentDidMount() {}

  render() {
    return (
      <Container style={{ maxWidth: 500, marginTop: 100, borderRadius: 5 }}>
        <LoginComponent
          onLoginSuccess={(response) => {
            localStorage.removeItem('AuthorizedAccounts');
            loadAuthorizedAccountsAfterLogin();
            const role = response.account.role;
            const targetRoute = role == 'private' ? '/FindMoorings' : '/home';
            this.props.history.push(targetRoute);
            window.location.reload();
          }}
        />
      </Container>
    );
  }
}

export default withTranslation()(Login);
